import React, { Component } from 'react';
import { NavBar, SearchBar, Toast } from 'antd-mobile';
import { ROOT_PATH } from '../../config';
import Table from '../../components/Table';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import send from "../../utils/send";

class Farrow19WkDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 'col1',
          title: '序号',
          fixed: true,
          width: 40,
          align: 'left',
        },
        {
          id: 'col2',
          title: '配种日期',
          align: 'right'
        },
        {
          id: 'col3',
          title: '耳号',
          align: 'right'
        },
        {
          id: 'col4',
          title: '胎次',
          align: 'right'
        },
        {
          id: 'col5',
          title: '返情',
          align: 'right'
        },
        {
          id: 'col6',
          title: '流产',
          align: 'right'
        },
        {
          id: 'col7',
          title: '空怀',
          align: 'right'
        },
        {
          id: 'col8',
          title: '淘汰',
          align: 'right'
        },
        {
          id: 'col9',
          title: '死亡',
          align: 'right'
        },
        {
          id: 'col10',
          title: '怀孕',
          align: 'right'
        },
        {
          id: 'col11',
          title: '分娩',
          align: 'right'
        }
      ],
      dataSource: [],
      details: []
    }
  }

  getDetail = (obj) => {
    Toast.loading('加载中...', 0);
    axios.post(
      `${ROOT_PATH}/api/forward/ifarm/farrowDetailFor19Table`,
      qs.stringify(
        {
          'mateGroupStart': obj.startWeek,
          'mateGroupEnd': 0,
          'progarm': obj.type
        }
      ),
      {
        headers: {
          'x-http-appid': '1',
          'x-http-device': '0',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': TOKEN,
          'farmorg': FARM_ORG,
          'orgcode': ORG_CODE
        }
      }
    )
      .then(res => {
        Toast.hide();
        this.updateTable(res.data);
      })
      .catch(err => {
        return err;
      })
  };

  updateTable(data) {
    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      newObj['col1'] = data.indexOf(obj) + 1; //序号
      newObj['col2'] = (obj.transactionDate) !== undefined ? (obj.transactionDate) : '-'; //配种日期
      newObj['col3'] = (obj.swineTrack) !== undefined ? (obj.swineTrack) : '-'; //耳号
      newObj['col4'] = (obj.litno1) !== undefined ? (obj.litno1) : '-'; //胎次
      newObj['col5'] = (obj.abort_01) !== undefined ? (obj.abort_01) : '-'; //返情
      newObj['col6'] = (obj.abort_02) !== undefined ? (obj.abort_02) : '-'; //流产
      newObj['col7'] = (obj.abort_03) !== undefined ? (obj.abort_03) : '-'; //空怀
      newObj['col8'] = (obj.culled) !== undefined ? (obj.culled) : '-'; //淘汰
      newObj['col9'] = (obj.dead) !== undefined ? (obj.dead) : '-'; //死亡
      newObj['col10'] = (obj.gestation) !== undefined ? (obj.gestation) : '-'; //怀孕
      newObj['col11'] = (obj.farrow) !== undefined ? (obj.farrow) : '-'; //分娩
      dataSource.push(newObj);
    });

    this.setState({
      details: dataSource,
      dataSource
    });
  }

  componentDidMount() {
    this.getDetail(this.props.data);
  }

  componentWillUnmount() {
    this.setState = () => {

    }
  }

  search = (v) => {
    const results = this.state.dataSource.filter((obj) => {
      let swineId = obj.col3;
      return swineId.indexOf(v || '') >= 0
    });
    this.setState({
      details: results
    })
  };

  render() {
    return (
      <div className="report-detail-bg">
        <div className="report-header">
          <NavBar mode="light">19周分娩率</NavBar>
          <SearchBar
            onChange={this.search.bind(this)}
            placeholder="搜索"
          />
        </div>
        <div className="report-content">
          <Table columns={this.state.columns} data={this.state.details} />
        </div>
      </div>
    )
  }
}

export default Farrow19WkDetail;
